module.exports = __webpack_public_path__ + "img/1_024.e2ff4a76.jpg";